<template>
    
                <div class="news-items mt54">

                    <a href="https://mp.weixin.qq.com/s/ns0dVf3iwNHZwsk9Sj4n_Q" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251029/001.jpg" alt="源自澳门的一口好茶：「茶业新物种」如何重塑中国茶产业格局？" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/29<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">源自澳门的一口好茶：「茶业新物种」如何重塑中国茶产业格局？</div>
                                <div class="desc">一颗标准化的茶胶囊，背后是澳门新业态品牌隆兴澳1915与现代数字技术的深度融合，正通过澳门这个国际窗口，悄然开启一场从种植到品饮的产业链革命。 </div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/BW7J4lxxFW28tQPKosJgTA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251028/001.jpg" alt="中国电信展示“神农一号”大模型，澳门平台推动中葡智慧农业合作" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/28<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">中国电信展示“神农一号”大模型，澳门平台推动中葡智慧农业合作</div>
                                <div class="desc">澳门威尼斯人金光会展中心内，中国电信的“神农一号”大模型吸引了众多葡语国家代表驻足。作为智慧农业的大脑，它正通过澳门这座桥梁走向葡语世界。 </div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/lGJobnCeOYcbPPm3PVUD4g" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251027/001.jpg" alt="首届中葡农业国际博览会圆满落幕 成果丰硕 搭建中葡农业务实合作新高地" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/27<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">首届中葡农业国际博览会圆满落幕 成果丰硕 搭建中葡农业务实合作新高地</div>
                                <div class="desc">澳门金光会展中心内，科技与农业交汇，商机与合作共舞，中葡农业合作迎来崭新起点。首届中葡农业国际博览会于2025年10月22日在澳门威尼斯人金光会展中心正式开馆。本届博览会以"绿色农业·共享机遇·共谋发展"为主题，聚焦农业绿色转型与跨境合作，是深化中国与葡语国家农业高质量对接的重要实践，也是服务国家"一带一路"倡议的具体行动。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/z4SI9M_80KKf9L76eztx4w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251025/001.jpg" alt="圆满落幕!中葡可持续生态农产品合作高峰论坛绘就绿色贸易新蓝图" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/25<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">圆满落幕!中葡可持续生态农产品合作高峰论坛绘就绿色贸易新蓝图</div>
                                <div class="desc">10月23日，中葡可持续生态农产品合作高峰论坛在澳成功举办，来自中国、葡语国家及国际组织的200余位政企代表、专家学者齐聚一堂，以“生态共赢·贸易创新”为核心，共商农业可持续发展大计，为中葡农业合作注入全新动能。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/fnmFfNdA0x2xdoEaE2aQfw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251023/001.jpg" alt="首届中葡农业国际博览会澳门启幕，共筑中葡农业绿色合作新高地" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/23<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">首届中葡农业国际博览会澳门启幕，共筑中葡农业绿色合作新高地</div>
                                <div class="desc">首届中葡农业国际博览会在澳门威尼斯人金光会展中心正式开馆。本届博览会以“绿色农业·共享机遇·共谋发展”为主题，聚焦农业绿色转型与跨境合作，是深化中国与葡语国家农业高质量对接、服务国家“一带一路”倡议与“双循环”新发展格局的重要实践。开馆仪式由澳门招商投资促进局指导，中国农业展览协会、澳门中葡商贸促进协会共同主办。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/Hr3zdx6aKnzVqHuT00ej3w" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20251013/001.jpg" alt="2025澳门中葡农业国际博览会-参展指南" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/13<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">2025澳门中葡农业国际博览会-参展指南</div>
                                <div class="desc">2025澳门中葡农业国际博览会将于 2025 年 10 月 22 日在 澳门威尼斯人金光会展B厅 盛大开幕！澳门威尼斯人综艺馆展期临近，请收下这份最新「参展指南」</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/xHHVQUW7cM2_Rif8zQXrEQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250930/001.png" alt="融贯国际牵头启动澳门国际科创和企业服务中心" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/30<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际牵头启动澳门国际科创和企业服务中心</div>
                                <div class="desc">第五届数字贸易创新应用峰会上，由澳门融贯投资科技有限公司、珠海市香洲正菱控股有限公司等多家机构联合推动成立的“澳门国际科创和企业服务中心”正式举行启动仪式。标志着澳门在国际科技创新与跨境企业服务方面迈出关键一步。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/lVO_Gu_EPV3-VQqpQmC7FA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250929/001.jpg" alt="融贯国际携手湾区企业，标准与认证引领文化贸易新秩序" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/29<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际携手湾区企业，标准与认证引领文化贸易新秩序</div>
                                <div class="desc">在数字经济与全球化深入发展的背景下，跨境文化贸易的规范化与可信化建设日益成为关注焦点。粤港澳大湾区作为国家战略的重要平台，于第五届数字贸易创新应用峰会期间，正式推出“湾区艺术品鉴定评估中心”作为重要环节。该中心致力于构建标准化、专业化的鉴定评估体系，积极探索大湾区文化艺术资源互联互通与规则对接的有效路径。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/18fBaY-LAO62r1gLSdjVVQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250923/001.jpg" alt="融贯国际×星火链网破局跨境贸易新路径" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/23<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际×星火链网破局跨境贸易新路径</div>
                                <div class="desc">在数字经济快速发展的背景下，跨境贸易的高效流转与可信交互已成为企业提升国际市场竞争力的关键要素。在第五届数字贸易峰会上，“星火链网在跨境金融与贸易中的实际应用”专题环节，集中展示了区块链技术与实体经济深度融合的阶段性成果，为跨境贸易的数字化转型提供了实施路径。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/NAljwgaoQ2gkv7l1d_UddA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250916/001.png" alt="融贯国际以技术为基，搭建跨境可信贸易桥梁" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/16<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际以技术为基，搭建跨境可信贸易桥梁</div>
                                <div class="desc">近日，第五届数字贸易创新应用峰会成功举办。峰会以“数促擎新质·云链贸全球”为主题，第一环节聚焦“链通全球”，通过三大核心环节的有序推进，为破解跨境贸易痛点、搭建全球可信贸易桥梁提供了切实可行的实施框架，推动跨境贸易向高效化、可信化、标准化方向迈进。</div>
                            </div>
                        </div>
                    </a>

                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>